module.exports = "/images/rts.white.svg?c23d5b809dabc178307ad5ad20b58bc4";